
import { Behavior, ChartMetadata, ChartPlugin, t } from '@superset-ui/core';
import buildQuery from '../buildQuery';
import controlPanel from './controlPanel';
import transformProps from './transformProps';
import thumbnail from './images/line.png';
import example1 from './images/line-2.png';
import example2 from './images/line-3.png';
import { EchartsLineChartProps, EchartsLineFormData } from './types';
 
export default class EchartsLineChartPlugin extends ChartPlugin<
   EchartsLineFormData,
   EchartsLineChartProps
 > {
   constructor() {
     super({
       buildQuery,
       controlPanel,
       loadChart: () => import('./EchartsLine'),
       metadata: new ChartMetadata({
         behaviors: [Behavior.INTERACTIVE_CHART],
         category: t('Part of a Whole'),
         credits: ['https://echarts.apache.org'],
         description:
           t(`Line chart is used to visualize measurements taken over a given category. Line chart is a type of chart which displays information as a series of data points connected by straight line segments. It is a basic type of chart common in many fields.`),
         exampleGallery: [
           { url: thumbnail },
           { url: example1 },
           { url: example2 },
         ],
         name: t('Line Chart'),
         tags: [
           t('Popular'),
           t('ECharts'),
           t('Line'),
         ],
         thumbnail,
       }),
       transformProps,
     });
   }
}
 